export const PHOTOBLOG_POST_TEXTAREA = (id: number) => `photoblog-post-textarea-${id}`;
export const BLOG_POST_MENU_MORE = (id: number) => `blog-post-menu-more-${id}`;
export const BLOG_POST_COMMENT_MENU_MORE = (id: number) => `blog-post-comment-menu-more-${id}`;
